import { NgModule } from '@angular/core';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { AppAuthenticatedRoutingModule } from './app-authenticated-routing.module';

@NgModule({
  imports: [AppAuthenticatedRoutingModule, VmeCommonModule, VMEComponentsModule],
})
export class AppAuthenticatedModule {}
